import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';

import { TriangleDown } from '@air/next-icons';
import { cn } from '@air/utils-tailwind';

export type SelectIconProps = RadixSelect.SelectIconProps;

export const SelectIcon = forwardRef<HTMLSpanElement, SelectIconProps>(
  ({ children, className, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.SelectIcon
        asChild
        className={cn('size-4 shrink-0 text-grey-9', className)}
        {...restOfProps}
        ref={forwardedRef}
      >
        {children ? children : <TriangleDown />}
      </RadixSelect.SelectIcon>
    );
  },
);

SelectIcon.displayName = 'SelectIcon';
